import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { device, breakpoints } from '../../../utils/styled-component-mixins';
import useMediaQuery from '../../custom-hooks/useMediaQuery';
import onDOMContentLoaded from '../../../utils/on-dom-content-loaded';
import { useLocationContext } from './LocationContext';
import OfficeCard from './OfficeCard';
import useOnResize from '../../custom-hooks/use-on-resize';

const OfficeList = ({ thankYouMessage }) => {
  const { offices } = useLocationContext();

  const isDesktopLarge = useMediaQuery(device.desktopLg);
  const officeCards = offices.map(OfficeCard);
  const officeSlides = officeCards.map((card, index) => (
    <SwiperSlide key={index}>{card}</SwiperSlide>
  ));

  const marketoFormSetup = () => {
    const officeListContainer = document.querySelector('.office-list-container');
    const marketoFormContainer = document.querySelector('.contact-form-container');
    officeListContainer?.appendChild(marketoFormContainer ?? null);
    marketoFormContainer?.removeAttribute('hidden');

    // set success message
    const successMessage = marketoFormContainer.querySelector('.formSuccessMessage');
    successMessage.innerHTML = thankYouMessage;
  };

  const moveMarketoForm = () => {
    const officeListContainer = document.querySelector('.office-list-container');
    const marketoFormContainer = document.querySelector('.contact-form-container');
    officeListContainer?.removeChild(marketoFormContainer ?? null);
    if (window.innerWidth > breakpoints.desktopLg) {
      officeListContainer?.appendChild(marketoFormContainer ?? null);
    } else {
      officeListContainer?.prepend(marketoFormContainer ?? null);
    }
  };

  onDOMContentLoaded().then(marketoFormSetup);

  useOnResize(() => {
    moveMarketoForm();
  });

  return (
    <div className="office-list-container">
      {isDesktopLarge ? (
        <ul className="office-list">{officeCards}</ul>
      ) : (
        <Swiper
          className="office-slider"
          modules={[Pagination]}
          pagination={{ clickable: false }}
          spaceBetween={16}
          slidesPerView="auto"
          centeredSlides
        >
          {officeSlides}
        </Swiper>
      )}
    </div>
  );
};

export default OfficeList;
